export default __webpack_public_path__ + "static/festl-brass-festzelt-preview-926ab2c49dea4c971b5f3925923914df.jpg";